import { format, isBefore, parseISO } from 'date-fns';
import styled from '@emotion/styled';
import { Chip, Typography } from '@mui/material';
import { RemoveCircle } from '@mui/icons-material';
import { JobDetail, OrderJob } from '@/redux/slices/slice_types';
import { formatDate } from '@/_utils/date';
import { useTranslation } from 'react-i18next';

type JobsEmbargoDateProps = {
  job?: OrderJob | JobDetail;
};

const JobsEmbargoDate = ({ job }: JobsEmbargoDateProps) => {
  const { t } = useTranslation();
  if (!job?.embargo_date) return null;
  const today = new Date();
  const embargoDate = parseISO(job.embargo_date);

  if (job.status && job.status.includes('cancel')) return null;
  return (
    <StyledChip
      iconcolor={isBefore(new Date(today.toDateString()), new Date(embargoDate.toDateString())) ? '#838ea1' : 'error'}
      icon={<RemoveCircle fontSize="small" />}
      color="default"
      label={
        <>
          <Typography variant="caption" color={isBefore(new Date(today.toDateString()), new Date(embargoDate.toDateString())) ? '#838ea1' : 'error'}>
            {t('Embargo')}
          </Typography>
          <Typography variant="caption" color={isBefore(new Date(today.toDateString()), new Date(embargoDate.toDateString())) ? 'inherit' : 'error'}>
            Until {formatDate(job.embargo_date)} {format(embargoDate, 'hh:mm aa')}
          </Typography>
        </>
      }
    />
  );
};

export default JobsEmbargoDate;

const StyledChip = styled(Chip)<{ iconcolor?: string }>`
  border: none;
  background-color: ${({ theme }) => (theme.palette.mode === 'dark' ? '#0f0f17' : 'auto')};

  & .MuiChip-icon {
    color: ${(props) => (props.iconcolor === 'error' ? props.theme.palette.error.main : props.iconcolor)};
  }

  & .MuiChip-label {
    display: flex;
    column-gap: 0.5rem;
    align-items: center;
  }
`;
